import { entities } from "sb-bff-integration";
export function textDatePeriodTime(masterEvent, dict) {
    if (masterEvent.isLive) {
        if (masterEvent.liveStartCountdown > 0) {
            return `${dict.StartsIn} ${masterEvent.formattedCountdown}`;
        }
        if (masterEvent.liveGameState
            && masterEvent.liveGameState.gamePart) {
            return `${dict[masterEvent.liveGameState.gamePart]} ${shouldShowTime(masterEvent) ?
                masterEvent.liveGameState.formattedTime :
                ""}`;
        }
        return "";
    }
    return masterEvent.eventDate;
}
export function textTimeScore(masterEvent) {
    if (masterEvent.isLive) {
        if (masterEvent.liveGameState) {
            return `${masterEvent.score1 || ""}-${masterEvent.score2 || ""}`;
        }
        return "";
    }
    return masterEvent.eventTime;
}
function shouldShowTime(masterEvent) {
    return !getInactiveGamesStates().some(status => (!!masterEvent.liveGameState &&
        (masterEvent.liveGameState.gamePart && masterEvent.liveGameState.gamePart === status
            || masterEvent.liveGameState.gameTime === null)));
}
function getInactiveGamesStates() {
    return [entities.GamePart.BreakAfterFirstOvertime,
        entities.GamePart.BreakAfterFirstPeriod,
        entities.GamePart.BreakAfterSecondPeriod,
        entities.GamePart.BreakAfterThirdPeriod,
        entities.GamePart.BreakAfterFirstQuarter,
        entities.GamePart.BreakAfterSecondQuarter,
        entities.GamePart.BreakAfterThirdQuarter,
        entities.GamePart.BreakAfterFourthQuarter,
        entities.GamePart.BreakAfterFirstHalf
    ];
}
//# sourceMappingURL=getTextDate.js.map